import { axios } from "@axios";

export type ContractRecord = {
  uploadedAt?: string;
  stage?: string;
  fileUrl?: string;
};

export type BorrowerContractResponse = {
  fileUrl?: string;
  stage?: string;
  message?: string;
};

export const getBorrowerContract = (
  borrowerUuid: string,
  offerId: string
): Promise<BorrowerContractResponse> => {
  return axios.get("/user/borrower-contract", {
    params: { borrowerUuid, offerId },
  });
};

export const emailSignedContractConfirmation = (payload: {
  offerId: string;
  applicationId: string;
  borrowerUuid: string;
  lenderUuid: string;
  stage: string;
}): Promise<unknown> => {
  return axios.post("/user/email-signed-contract", payload);
};

export const getLatestContractFromApplication = (
  contracts?: ContractRecord[]
): ContractRecord | null => {
  if (!Array.isArray(contracts) || contracts.length === 0) return null;
  return [...contracts].sort(
    (a, b) =>
      new Date(b.uploadedAt || 0).getTime() -
      new Date(a.uploadedAt || 0).getTime()
  )[0];
};

export const resolveBorrowerUuid = (storedUser: any): string | undefined => {
  return (
    storedUser?.user?.userId ??
    storedUser?.user?.uuid ??
    storedUser?.userId ??
    storedUser?.uuid
  );
};
